var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 500,
    viewBox: "0 0 486 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M240.929 498.213C374.222 498.213 483.196 387.074 484.326 249.977C485.458 112.88 378.319 1.7395 245.024 1.7395C111.731 1.7395 2.75717 112.88 1.62606 249.977C0.494964 387.074 107.634 498.213 240.929 498.213Z",
    stroke: "url(#paint0_linear_5_438)",
    strokeWidth: 1.84726,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_438",
    x1: 244.983,
    y1: 1.156,
    x2: 244.983,
    y2: 498.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161A24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#161A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161A24",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d70363de8e9d81aae0dd47f8a91ac2f8.svg";
export { ForwardRef as ReactComponent };